export const fullNameValidator = {
  validate (value, args) {
    return RegExp(/\S+( +\S+)+/).test(value);
  },
};
